/** Ce que renvoie `GET /evenementiel/:id/collecte/live-checkins` — le Jour J, table par table. */
export interface DishAllergyCount { text: string; count: number; removable?: boolean; }
export interface DishRow {
    dish_id: string; base_name: string; variant_label: string | null; removals?: string[]; allergy_reasons?: string[];
    name: string; is_alternative: boolean; count: number; prepared: boolean; prepared_count: number | null; count_mismatch: boolean; allergies: DishAllergyCount[];
}
export interface TableGuest { id: string; name: string; first_name?: string; last_name?: string; checked_in_at: string; dishes: string[]; allergies?: string[]; restrictions?: string[]; medical_note?: string }

/** « CAZAUX Lucie » — le nom d'abord, en capitales : c'est ainsi qu'on l'annonce au passe. */
export const nomAnnonce = (g: TableGuest) => g.last_name ? `${g.last_name.toUpperCase()} ${g.first_name || ''}`.trim() : g.name;
export interface TableRow { table_number: string; is_vip?: boolean; guests: TableGuest[]; dish_counts_by_category: Record<string, DishRow[]>; }
export interface LiveCheckins { tables: TableRow[]; total_checked_in: number; }

/** Les contraintes d'une table, nommées : « CAZAUX Lucie — sans gluten ». Allergies d'abord. */
export const contraintesDeTable = (t: TableRow): { who: string; what: string; allergie: boolean; medicale?: boolean }[] => {
    const out: { who: string; what: string; allergie: boolean; medicale?: boolean }[] = [];
    t.guests.forEach((g) => {
        (g.allergies || []).forEach((a) => out.push({ who: nomAnnonce(g), what: a, allergie: true }));
        (g.restrictions || []).forEach((r) => out.push({ who: nomAnnonce(g), what: r, allergie: false }));
        // La note médicale (grossesse, diabète) manquait au passe, alors que l'écran du convive lui dit
        // « pris en compte en cuisine ». Elle change l'assiette autant qu'un régime : elle s'annonce aussi.
        const note = String(g.medical_note || '').trim();
        if (note) out.push({ who: nomAnnonce(g), what: note, allergie: false, medicale: true });
    });
    return out;
};

/** Numéros de table triés naturellement (« 2 » avant « 10 »). */
export const compareTables = (a: string, b: string) => a.localeCompare(b, 'fr', { numeric: true });

// Regroupe les lignes plat+variante par plat de base, pour que le chef comprenne d'un coup d'œil "28 Lieu
// Noir, dont 3 sans sauce" plutôt qu'une liste plate de lignes indépendantes. Un plat sans aucune variante
// choisie à cette table reste affiché seul, sans sous-groupe inutile. Demande explicite d'Emeni (2026-08-23) :
// "il doit vraiment bien comprendre ce qu'il doit préparer de manière simple".
export const groupDishesByBase = (dishes: DishRow[]) => {
    const order: string[] = [];
    const byBase = new Map<string, DishRow[]>();
    dishes.forEach((d) => {
        if (!byBase.has(d.base_name)) { byBase.set(d.base_name, []); order.push(d.base_name); }
        byBase.get(d.base_name)!.push(d);
    });
    return order.map((baseName) => {
        const rows = byBase.get(baseName)!.slice().sort((a, b) => (a.variant_label ? 1 : 0) - (b.variant_label ? 1 : 0));
        return { baseName, rows, total: rows.reduce((sum, r) => sum + r.count, 0) };
    });
};
